export const storeTypeList = [
  { value: '', label: 'All' },
  { value: 'affiliate', label: 'Affiliate' },
  { value: 'marketplace', label: 'Marketplace' },
]

export const subscriptionStatusList = [
  { value: '', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'subscribed', label: 'Subscribed' },
  { value: 'terminated', label: 'Terminated' },
]

export const subscriptionColumnList = [
  { type: 'id', custom: { width: '60' } },
  { type: 'type', custom: { width: '120' } },
  { type: 'payment_source', custom: { width: '120' } },
  { type: 'name', custom: { width: '250' } },
  { type: 'plan_name', custom: { width: '200' } },
  { type: 'plan_monthly_price', custom: { width: '120' } },
  { type: 'billing_interval', custom: { width: '80' } },
  { type: 'next_billing_date', custom: { width: '100' } },
  { type: 'terminated_date', custom: { width: '100' } },
]